import { Link } from "react-router-dom";

const Logo = () => (
  <Link to="/" className="navbar__logo">
    LITERA
  </Link>
);

export default Logo;
